var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificacao",class:[_vm.infos.variant, { form: _vm.form }],attrs:{"data-anima":"top"}},[_vm._v(" "+_vm._s(_vm.infos.mensagem)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }